// components/navbar/InboxButton.tsx
import React, { useState } from 'react';
import inboxIcon from '../../assets/icons/inboxButton.svg';
import unseenIcon from '../../assets/icons/unseenIcon.svg';
import styles from './Navbar.module.css';
import { useInboxStatus } from './useInboxStatus';
import { User } from '../../gql/types';
import { InboxConnection } from '../inbox/types';
import InboxPortalView from '../inbox/InboxPortalView';

interface Props {
    user?: User;
    onClick?: (precomputedInboxConnection?: InboxConnection) => void;
}

const InboxButton: React.FC<Props> = ({ user, onClick }) => {
    const { hasUnseenRequestUpdates, precomputedInboxConnection } = useInboxStatus(user);

    return (
        <button
            className={`${styles.navbarButton} ${styles.rightSideButton}`}
            onClick={() => onClick?.(precomputedInboxConnection)}
        >
            <img src={inboxIcon} />
            {hasUnseenRequestUpdates && <img src={unseenIcon} className={styles.unseenIcon} />}
        </button>
    );
};

export default InboxButton;
